import { useContext } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faToggleOn } from '@fortawesome/pro-light-svg-icons'

import { Button, Tools } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import useInvoice from '@hooks/useInvoice'

interface InvoiceToolsProps {
  invoicePayload: ReturnType<typeof useInvoice>,
}

const InvoiceTools = (props: InvoiceToolsProps) => {
  const {
    invoicePayload: {
      callbacks: {},
      loading,
    },
  } = props

  const pageContext = useContext(PageContext)
  const { callbacks } = pageContext

  return (
    <Tools>
      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faToggleOn} />}
        onClick={() => console.log('Clicked!')}
        size="medium"
      >
        Custom Action
      </Button>
    </Tools>
  )
}

export default InvoiceTools
